export enum CollectionMethod {
    LOCAL = 'local',
    SWIFT = 'swift',
}

export interface CollectionPayload {
    senderName: string
    senderAccountNumber: string
    senderBankCountry?: string
    senderBankBIC?: string
    receiverName: string
    receiverAccountNumber: string
    amount: number
    currency: string
    method: CollectionMethod | string
    customerReference: string
}

export interface CollectionRetrieve {
    id: string
    accountId: string
    collectionAccountId: string
    status: string
    reference: string
    provider?: string
    accountNumber: string
}

export interface CollectionStatus {
    value: string
    description: string
    available: string[]
}

export default class Collection {
    static statuses(collection: CollectionRetrieve): CollectionStatus[] {
        const statuses: Array<CollectionStatus> = [
            {
                value: 'pending',
                description: 'Pending',
                available: [],
            },
            {
                value: 'completed',
                description: 'Completed',
                available: ['pending'],
            },
            {
                value: 'rejected',
                description: 'Rejected',
                available: ['pending'],
            },
        ]

        return statuses.filter((status) => status.available.includes(collection.status) || collection.status === status.value)
    }

    private static getAccountStatusByProvider(provider?: string): Array<CollectionStatus> {
        switch (provider) {
            case 'dbs_sg':
                return [
                    {
                        value: 'active',
                        description: 'Active',
                        available: ['pending'],
                    },
                    {
                        value: 'pending',
                        description: 'Pending',
                        available: ['inactive'],
                    },
                    {
                        value: 'inactive',
                        description: 'Inactive',
                        available: [],
                    },
                    {
                        value: 'disabled',
                        description: 'Disabled',
                        available: ['active', 'pending', 'inactive'],
                    },
                ]
            case 'dbs_hk':
                return [
                    {
                        value: 'active',
                        description: 'Active',
                        available: ['inactive'],
                    },
                    {
                        value: 'inactive',
                        description: 'Inactive',
                        available: [],
                    },
                    {
                        value: 'disabled',
                        description: 'Disabled',
                        available: ['active', 'pending', 'inactive'],
                    },
                ]
            default:
                return [
                    {
                        value: 'disabled',
                        description: 'Disabled',
                        available: ['active', 'inactive', 'pending', 'enabled'],
                    },
                    {
                        value: 'inactive',
                        description: 'Inactive',
                        available: [],
                    },
                    {
                        value: 'active',
                        description: 'Active',
                        available: [],
                    },
                    {
                        value: 'pending',
                        description: 'Pending',
                        available: [],
                    },
                    {
                        value: 'enabled',
                        description: 'Enabled',
                        available: [],
                    },
                ]
        }
    }

    static accountStatuses(collection: { status: string; provider?: string }): CollectionStatus[] {
        const statuses = this.getAccountStatusByProvider(collection?.provider)

        return statuses.filter((status) => status.available.includes(collection.status) || collection.status === status.value)
    }
}
